import { Component, Input, OnInit, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { skip } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent, StorageService, UserService, ProductService, ExchangeService, environment } from "@mypxplat/xplat/core";
import { Router } from "@angular/router";
import { ExchangeRequireStudiooneComponent } from "../modals";
import { AppService, AvoService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "myp-exchange-list-item",
  templateUrl: "exchange-list-item.component.html",
  standalone: false,
})
export class ExchangeListItemComponent extends BaseComponent implements OnInit {
  @Input() item: any;
  @Input() grid: any;
  @Output() itemTapped: EventEmitter<number> = new EventEmitter();
  @Output() updateFavorites: EventEmitter<boolean> = new EventEmitter();

  constructor(
    storageService: StorageService,
    userService: UserService,
    public appService: AppService,
    public productService: ProductService,
    public translate: TranslateService,
    public exchangeService: ExchangeService,
    public avoService: AvoService,
    private cdr: ChangeDetectorRef
  ) {
    super(userService);
    // The unpublished/not-approved badges compare against user.id, which BaseComponent updates from user$.
    this.userService.user$.pipe(skip(1), takeUntilDestroyed()).subscribe(() => this.cdr.markForCheck());
  }

  ngOnInit() {}

  go(args) {
    this.itemTapped.next(this.item.id);
  }

  favorite(args) {
    args.stopPropagation();
    if (this.user || this.userService.cookieUser) {
      this.exchangeService.markAsFavorite(this.item.id).subscribe((result) => {
        this.updateFavorites.next(true);
        this.item.favorite = !this.item.favorite;
        this.cdr.markForCheck();
      });
    } else {
      window.location.href = environment.mypresonusUrl + "/login?return_to_app=exchange&redirect_to=" + window.location.href;
    }
  }

  download(args) {
    args.stopPropagation();
    if (this.user || this.userService.cookieUser) {
      if (this.productService.hasElligibleS1ForExchange) {
        if (this.item.downloads && this.item.downloads.length) {
          this.item.downloads.forEach((dl) => {
            if (dl.contentRole == "PRIMARY") {
              this.exchangeService.downloadWare(this.item.id, dl.id).subscribe((result: any) => {
                window.location.href = result.download_url;
              });
              const typeParts = dl.fileName.split(".");
              const type = typeParts[typeParts.length - 1];
              const page = this.avoService.getPageProperties({ pageName: "Exchange" });
              const extra = {
                productFileName: dl.fileName,
                productFileSize: parseInt(dl.contentLength, 10),
                productId: this.item.id.toString(),
                productName: this.item.title,
                productFileType: type,
                exchange: true,
              };
              const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
              this.avoService.trackEvent().fileDownloaded(payload);
            }
          });
        }
      } else {
        const modalRef = this.appService.showModal(ExchangeRequireStudiooneComponent, { size: "sm" });
      }
    } else {
      window.location.href = environment.mypresonusUrl + "/login?return_to_app=exchange&redirect_to=" + window.location.href;
    }
  }
}
